import { useCallback, useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
import reducer from './reducer';
import { ACTIONS } from './constants';
import { SORT_DIRECTIONS, STATUS } from '@app/constants/commonConstants';

const useListSorting = ({
  sortDir = SORT_DIRECTIONS.ASC,
  sortId,
  sortType,
  selector = null,
  statusSelector = null
}) => {
  const initialState = {
    sortBy: sortId,
    sortDirection: sortDir,
    sortOrder: [],
    sortType
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const initialData = useSelector(selector);
  const status = useSelector(statusSelector);
  const isResolvedOrRejected = status === STATUS.RESOLVED || STATUS.REJECTED;

  const handleSort = useCallback(
    sortData => {
      const { sortBy, sortType, sortDirection, sortOrder } = sortData;
      dispatch({
        type: ACTIONS.SORT,
        payload: {
          sortBy: sortBy,
          type: sortType,
          dir: sortDirection,
          order: sortOrder,
          data: initialData
        }
      });
    },
    [initialData]
  );

  const initializeSort = useCallback(() => {
    dispatch({
      type: ACTIONS.INITIALIZE_SORT,
      payload: {
        sortBy: sortId,
        sortDirection: sortDir,
        sortOrder: [],
        sortType,
        listData: initialData
      }
    });
  }, [sortDir, sortId, sortType, initialData]);

  useEffect(() => {
    if (isResolvedOrRejected) {
      initializeSort();
    }
  }, [initializeSort, isResolvedOrRejected]);

  return { handleSort, state };
};

export default useListSorting;
